import Swiper from 'swiper/bundle';

import '../block/videos';
import '../block/sliderCursor';
import options from '../block/swiperOptions';

import photoNavigate from '../page/photos/navigate';
import photoHtml from '../page/photos/html';
import photoModal from '../page/photos/modal';
import photoMasonry from './photos/masonry';
import photoLoaded from './photos/photoLoaded';

var archive = {
    init: function () {
        archive.loading();
        archive.swipers();
        archive.photosObjects();
        archive.photoItems();

    },

    loading: function () {
        $('.section-main').animate({
            opacity: 1
        }, 1000)
    },

    swipers: function () {

        // Темы
        ZoneObject.create('.section-themes', {
            run: () => {
                new Swiper('.swiper-2', $.extend(options, {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                }));
            }
        });

        // Карточки файлов
        ZoneObject.create('.section-docs', {
            run: () => {
                new Swiper('.swiper-1', $.extend(options, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            spaceBetween: 20
                        }
                    }
                }));
            }
        });

        // Партнеры
        ZoneObject.create('.section-companies', {
            run: () => {
                // Партнеры
                new Swiper('.swiper-2', $.extend(options, {
                    slidesPerView: 'auto',
                    spaceBetween: 20
                }));
            }
        });

        // Карточки партнеров
        ZoneObject.create('.section-partner', {
            run: () => {
                // Карточки партнеров
                new Swiper('.swiper-partner', $.extend(options, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            spaceBetween: 20
                        }
                    }
                }));
            }
        });
    },

    photosObjects: function () {
        var parent = $('.section-photos__grid');

        parent.each(function () {
            $(this).find('.section-photos__item').slice(7).hide();
        });

    },

    photoItems: function () {
        items.create({
            name: 'photo',
            first_load: true,
            html: photoHtml,
            modal: photoModal,
            onPrint: (response) => {
                photoNavigate(response);
                photoLoaded(photoMasonry);
            }
        });
    }
}

$(archive.init)